import { useSelector } from 'react-redux'

import type { RootState } from '~publish/legacy/store'

export const useTwentyFourHourTimeFormat = (): boolean =>
  useSelector((state: RootState) => state.user.hasTwentyFourHourTimeFormat)
